import React from 'react'
import * as Errors from '@morningtrain/react-errors'
import AdminMainNavigation from 'widgets/navigation/AdminMainNavigation'
import AdminTopNavigation from 'widgets/navigation/AdminTopNavigation'
import { ResetSmartviewOnNavigate } from '@morningtrain/react-smartviews'
import WithSidebarAndHeader from 'ui/layouts/WithSidebarAndHeader'
import Logo from 'widgets/branding/Logo'
import { Link } from '@morningtrain/react-navigation'
import ImpersonationBar from 'widgets/impersonation/ImpersonationBar'

export default function Admin (props) {
  const logoSection = (
    <Link route='app.home.home'>
      <Logo className='h-auto w-44 block' />
    </Link>
  )

  return (
    <WithSidebarAndHeader
      sidebar={<AdminMainNavigation />}
      header={<AdminTopNavigation />}
      logo={logoSection}
    >
      <ResetSmartviewOnNavigate />
      <Errors.Boundary>
        <ImpersonationBar />
        {props.children}
      </Errors.Boundary>
    </WithSidebarAndHeader>
  )
}
